import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { MdTableCell } from '../common/MdRowActions';
import { SELECT_LABELS, selectPlaceholder, withSelectPlaceholder } from '../../services/selectOptions';

const RESULTADO_OPTIONS = withSelectPlaceholder(
  [
    { value: 'R', label: 'Regular' },
    { value: 'L', label: 'Libre' },
  ],
  SELECT_LABELS.resultado
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class CargarActaCursada extends Component {
  static displayName = CargarActaCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      saving: false,
      loadError: '',
      errorMessage: '',
      alumnos: [],
      materia: '',
      id: this.props.match.params.id,
      resultados: {},
      redirect: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (constantClass.canAccess('WWActasCursado')) {
      this.populateData();
    } else {
      this.setState({ loading: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleResultadoChange = (alumnoId, option) => {
    this.clearFeedback();
    const resultado = option && option.value ? option.value : '';
    this.setState((prev) => ({
      resultados: {
        ...prev.resultados,
        [alumnoId]: resultado,
      },
    }));
  };

  getResultadoValue(alumnoId) {
    const resultado = this.state.resultados[alumnoId];
    if (!resultado) {
      return selectPlaceholder(SELECT_LABELS.resultado);
    }
    return RESULTADO_OPTIONS.find((option) => option.value === resultado) || selectPlaceholder(SELECT_LABELS.resultado);
  }

  allRowsWereSaved() {
    return this.state.alumnos.every((alumno) => {
      const resultado = this.state.resultados[alumno.detalleActaCursadaCod];
      return resultado === 'R' || resultado === 'L';
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.saving)) return;

    if (!this.allRowsWereSaved()) {
      this.setState({ errorMessage: 'Debe cargar el resultado de todos los alumnos.' });
      return;
    }

    this.postNotas();
  }

  renderTable(alumnos) {
    if (!alumnos.length) {
      return <p className="md-form-page__empty-hint">No hay alumnos para cargar en esta acta.</p>;
    }

    const isBusy = this.state.loading || this.state.saving;

    return (
      <div className="md-page__table-card">
        <table className="md-page__table" aria-labelledby="cargar-acta-cursada-title">
          <thead>
            <tr>
              <th scope="col">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col">Resultado</th>
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => (
              <tr key={alumno.detalleActaCursadaCod}>
                <MdTableCell>{alumno.alumnoDni}</MdTableCell>
                <MdTableCell>{alumno.alumnoNombre}</MdTableCell>
                <td>
                  <div className="md-form-page__select-wrap">
                    <Select
                      classNamePrefix="md-form-page__select"
                      options={RESULTADO_OPTIONS}
                      value={this.getResultadoValue(alumno.detalleActaCursadaCod)}
                      classNames={SELECT_CLASS_NAMES}
                      isDisabled={isBusy}
                      placeholder="Seleccione el resultado"
                      onChange={(option) => this.handleResultadoChange(alumno.detalleActaCursadaCod, option)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-acur" />;
    }

    const { loading, saving, loadError, errorMessage, alumnos, materia } = this.state;
    const isBusy = loading || saving;

    const contents = loading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(alumnos);

    return (
      <div className="md-page md-form-page md-cargar-acta-cursada">
        <Link className="md-form-page__back" to="/md-acur">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 id="cargar-acta-cursada-title" className="md-form-page__title">
          Cargar Resultados de Acta de Cursada
        </h1>

        {materia ? (
          <p className="md-form-page__subtitle">Materia: {materia}</p>
        ) : null}

        <div className="md-form-page__feedback" aria-live="polite" role="status">
          {loadError ? (
            <div className="md-form-page__error" role="alert">{loadError}</div>
          ) : null}
        </div>

        <form className="md-form-page__form" onSubmit={this.handleSubmit}>
          {contents}

          {!loading && alumnos.length > 0 ? (
            <>
              <div className="md-form-page__feedback md-form-page__feedback--before-actions" aria-live="polite" role="status">
                {errorMessage ? (
                  <div className="md-form-page__error" role="alert">{errorMessage}</div>
                ) : null}
                {saving ? (
                  <div className="md-form-page__loading">Guardando resultados...</div>
                ) : null}
              </div>
              <div className="md-form-page__actions">
              <button
                type="submit"
                className="md-form-page__btn md-form-page__btn--primary"
                disabled={isBusy}
              >
                {saving ? 'Guardando...' : 'Guardar resultados'}
              </button>
              </div>
            </>
          ) : null}
        </form>
      </div>
    );
  }

  async populateData() {
    this.setState({ loading: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/acur/detalle/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudo cargar el detalle del acta.'
        ),
      });
      return;
    }

    const alumnos = Array.isArray(data.returnModel) ? [...data.returnModel] : [];
    alumnos.sort((a, b) => String(a.alumnoNombre).localeCompare(String(b.alumnoNombre), 'es'));

    const materia = alumnos.length > 0
      ? alumnos[0].materiaCarreraNombre.trim() + ' - ' + alumnos[0].carreraNombre.trim()
      : '';

    this.setState({
      alumnos,
      materia,
      loading: false,
      resultados: {},
    });
  }

  async postNotas() {
    if (isSubmitInProgress(this.state.saving)) return;

    this.setState({ saving: true, errorMessage: '' });

    const objects = this.state.alumnos.map((alumno) => ({
      DetalleActaCursadaCod: alumno.detalleActaCursadaCod,
      DetalleActaCursadaResultado: this.state.resultados[alumno.detalleActaCursadaCod],
    }));

    const { data } = await constantClass.apiFetch('api/acur', {
      method: 'POST',
      body: JSON.stringify(objects),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        saving: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudieron guardar los resultados. Intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ saving: false, redirect: true });
  }
}
